import {
    Create,
    Datagrid,
    DeleteButton,
    Edit,
    List,
    NumberField,
    required,
    Show,
    ShowButton,
    SimpleForm,
    SimpleShowLayout,
    TextField,
    TextInput
} from 'react-admin'
import DateTimeField from "../Components/Fields/DateTimeField";
import ListActions from "../Components/Toolbars/TopToolbars/ListActions";
import ShowActions from "../Components/Toolbars/TopToolbars/ShowActions";
import EditActions from "../Components/Toolbars/TopToolbars/EditActions";
import CreateActions from "../Components/Toolbars/TopToolbars/CreateActions";
import CreateToolbar from "../Components/Toolbars/BottomToolbars/CreateToolbar";
import Aside from "../Components/Aside";
import CompanyInput from "../Components/Inputs/CompanyInput";
import CompanyField from "../Components/Fields/CompanyField";

const Title = ({record}) => {
    return <span>{record ? `${record.code}` : ''}</span>;
};

export const LanguageList = (props) => (
    <List
        title="ra.page.languages"
        sort={{ field: 'updatedAt', order: 'DESC' }}
        aside={<Aside filters={{
            id: 'live',
            code: 'live',
            createdAt: 'dateRange'
        }}/>} {...props} actions={<ListActions/>} >
        <Datagrid rowClick="edit">

            <NumberField label="#" source="originId" sortBy={'id'}/>

            <TextField label="ra.field.code" source={'code'}/>

            <CompanyField label="ra.field.company"/>

            <DateTimeField label="ra.field.createdAt" source={'createdAt'}/>
            <DateTimeField label="ra.field.updatedAt" source={'updatedAt'}/>

            <ShowButton/>
            <DeleteButton/>

        </Datagrid>
    </List>
);

export const LanguageShow = (props) => (
    <Show actions={<ShowActions/>} title={<Title/>} {...props}>
        <SimpleShowLayout>

            <TextField label="ra.field.code" source={'code'}/>

            <TextField label="ra.field.company"/>
            <CompanyField/>

            <DateTimeField label="ra.field.createdAt" source={'createdAt'}/>
            <DateTimeField label="ra.field.updatedAt" source={'updatedAt'}/>

        </SimpleShowLayout>
    </Show>
);

export const LanguageEdit = (props) => (
    <Edit actions={<EditActions/>} title={<Title/>} {...props}>
        <SimpleForm>

            <TextInput label="ra.field.code" source="code"/>

            <CompanyInput label="ra.field.company"/>

        </SimpleForm>
    </Edit>
)

export const LanguageCreate = (props) => (
    <Create actions={<CreateActions/>} {...props}>
        <SimpleForm toolbar={<CreateToolbar/>}>

            <TextInput label="ra.field.code" source="code" validate={required()}/>

            <CompanyInput label="ra.field.company"/>

        </SimpleForm>
    </Create>
);
